export const apps = $axios => ({
  create: (params = {}) => $axios.$post('/builder/apps', params),
});
